import { RefObject, useEffect } from 'react';

interface UseOutsideClickProps {
  ref: RefObject<HTMLElement>;
  handler: () => void;
  activate?: boolean;
  ignoreRef?: RefObject<HTMLElement> | null;
  ignoreId?: string | null;
}

export function useOutsideClick({
  ref,
  handler,
  activate = true,
  ignoreRef = null,
  ignoreId = null,
}: UseOutsideClickProps): void {
  useEffect(() => {
    if (!activate || !handler) return;

    const listener = (event: MouseEvent | TouchEvent): void => {
      const target = event.target as Node;

      if (
        !ref.current ||
        ref.current.contains(target) ||
        (ignoreRef?.current && ignoreRef.current.isEqualNode(target)) ||
        (ignoreId && (target as HTMLElement).id === ignoreId)
      ) {
        return;
      }
      handler();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, activate, ignoreRef, ignoreId]);
}
